import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {getDebugConsoleVisible} from "../../store/reducers/debug-console/visible";
import {toggleDebugConsole} from "../../store/actions/debug-console/visible";
import {showGameOverModal, showModal, showTimerStartModal} from "../../store/actions/modals";
import {MODALS} from "../../store/reducers/modal";
import {pauseTimer, resumeTimer, startTimer, stopTimer} from "../../store/actions/timer";
import {showHint} from "../../store/actions/hints";
import {chooseRelevantOutage, setOutageID} from "../../store/actions/outages";
import {showNextOutageQuestion} from "../../store/actions/questions/questions";
import {setEventID} from "../../store/actions/events";
import {getScore} from "../../store/reducers/score";

export interface IDebugConsoleProps
{
    visible: boolean;
    toggleConsole: (visible: boolean) => void;
    showModal: (modal_id: string) => void;

    startTimer: () => void;
    stopTimer: () => void;
    pauseTimer: () => void;
    resumeTimer: () => void;

    showMainMenu: () => void;
    showStartTimer: () => void;
    showHint: () => void;
    showOutage: () => void;
    showQuestion: () => void;
    showEvent: () => void;
    showGameOver: () => void;
    skipToEnd: () => void;

    score: number;
}

import './DebugConsole.scss';
import handleOutages from "../../store/sagas/handleOutages";
import {setScreen} from "../../store/actions/screens";
import {SCREENS} from "../../store/reducers/screen";
import {setYear} from "../../store/actions/calendar/year";


class DebugConsole extends React.Component<IDebugConsoleProps, null>
{
    constructor(public props: IDebugConsoleProps)
    {
        super(props);
    }


    componentDidMount()
    {
        document.addEventListener('keyup', this.toggleConsole);
    }


    /**
     * toggle console visibility
     * @param {KeyboardEvent} event
     */
    toggleConsole = (event: KeyboardEvent) =>
    {
        if (event.keyCode === 223 || event.keyCode === 192) this.props.toggleConsole(! this.props.visible);
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        if (! this.props.visible) return null;

        return <div styleName={'debug-console'}>

            <h1>debug console</h1>

            <h3>modals</h3>

            <div styleName={'button-group'}>

                <button onClick={this.props.showMainMenu}>start game timer</button>
                <button onClick={this.props.showStartTimer}>start game timer</button>
                <button onClick={this.props.showOutage}>outage</button>
                <button onClick={this.props.showHint}>hint</button>
                <button onClick={() => this.props.showModal(MODALS.OUTAGE)}>power source</button>
                <button onClick={this.props.showQuestion}>question</button>
                <button onClick={this.props.showEvent}>event</button>
                <button onClick={this.props.showGameOver}>game over</button>
                <button onClick={() => this.props.showModal(null)}>none</button>
                <button onClick={this.props.skipToEnd}>skip</button>

            </div>

            <h3>timer</h3>

            <div styleName={'button-group'}>

                <button onClick={this.props.startTimer}>start</button>
                <button onClick={this.props.stopTimer}>stop</button>
                <button onClick={this.props.pauseTimer}>pause</button>
                <button onClick={this.props.resumeTimer}>resume</button>

            </div>

            <h3>score</h3>

            <p>{this.props.score}</p>

        </div>
    }
}


const mapStateToProps = state =>
{
    return {
        visible: getDebugConsoleVisible(state),
        score: getScore(state)
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        toggleConsole: (visible: boolean) => dispatch(toggleDebugConsole(visible)),
        showModal: (modal_id: string) => dispatch(showModal(modal_id)),
        startTimer: () => dispatch(startTimer()),
        stopTimer: () => dispatch(stopTimer()),
        pauseTimer: () => dispatch(pauseTimer()),
        resumeTimer: () => dispatch(resumeTimer()),
        skipToEnd: () => dispatch(setYear(12)),

        showMainMenu: () => dispatch(setScreen(SCREENS.MAIN_MENU)),
        showStartTimer: () => dispatch(showTimerStartModal()),
        showHint: () => dispatch(showHint('low-energy-mix')),
        showOutage: () => dispatch(chooseRelevantOutage()),
        showQuestion: () => dispatch(showNextOutageQuestion('low-energy-mix')),
        showEvent: () => dispatch(setEventID('world-cup')),
        showGameOver: () => dispatch(showGameOverModal()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DebugConsole);



// WEBPACK FOOTER //
// ./src/ts/app/debug/DebugConsole.tsx